export type ReturnExceptionOverride =
  | 'CUSTOMER_RESTRICTION'
  | 'RETURN_WINDOW'
  | 'PRODUCT_RULE';

export const returnExceptionOverrideLabels: Record<
  ReturnExceptionOverride,
  string
> = {
  CUSTOMER_RESTRICTION: 'customer restriction',
  RETURN_WINDOW: 'return window',
  PRODUCT_RULE: 'product return rule',
};

export interface ReturnExceptionItem {
  orderItemId: string;
  title: string | null;
  availableQuantity: number;
  blockers: string[];
  unavailable: boolean;
}

export interface ReturnException {
  id: string;
  orderId: string;
  storeId: string;
  items: Array<{ orderItemId: string; quantity: number }>;
  overrideCodes: string[];
  reason: string;
  expiresAt: string;
  createdAt: string;
  revokedAt: string | null;
  consumedAt: string | null;
  consumedReturnId: string | null;
  stale: boolean;
}

export interface ReturnExceptionOrder {
  orderId: string;
  items: ReturnExceptionItem[];
  exceptions: ReturnException[];
}

export interface GrantReturnExceptionInput {
  storeId: string;
  orderId: string;
  items: Array<{ orderItemId: string; quantity: number }>;
  overrideCodes: ReturnExceptionOverride[];
  reason: string;
  expiresAt: string;
}
